import { render } from "./seleccionarmesa.vue?vue&type=template&id=5664316d&scoped=true"
import script from "./seleccionarmesa.vue?vue&type=script&lang=js"
export * from "./seleccionarmesa.vue?vue&type=script&lang=js"

import "./seleccionarmesa.vue?vue&type=style&index=0&id=5664316d&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5664316d"]])

export default __exports__